$(document).on('turbolinks:load', function() {
  $('#tasks-table').dataTable({
    "processing": true,
    "serverSide": true,
    "ajax": {
      "url": $('#tasks-table').data('source')
    },
    "pagingType": "full_numbers",
    "columns": [
      {"data": "job"},
      {"data": "title"},
      {"data": "user"},
      {"data": "due_date"}, 
      {"data": "status"}, 
      {"data": "ops"},
    ], 
    columnDefs: [{ "orderable": false, "targets": 5 }, { "width": "5%", "targets": 5 },{ "className": 'dt-center', "targets": 5 }]
  });
});